/**
 * Hour tags on the hour views, pure: which hours carry which tags, which tags
 * cannot judge an hour, and each verdict in words.
 * For Media Devoted | Created By Ciro Autiero
 */
import { hourTagWhy, type DropGenHourBucket, type HourTagVerdict } from '@trafficpulse/shared';

type Tagged = Pick<DropGenHourBucket, 'tags'>;

export const hasHourTags = (rows: Tagged[]): boolean => rows.some((r) => r.tags && Object.keys(r.tags).length > 0);

const namesIn = (row: Tagged, state: HourTagVerdict['state']): string[] =>
  Object.entries(row.tags ?? {})
    .filter(([, v]) => v.state === state)
    .map(([name]) => name);

export const taggedNames = (row: Tagged): string[] => namesIn(row, 'tagged');
export const unknownNames = (row: Tagged): string[] => namesIn(row, 'unknown');

const STATE = { tagged: 'tagged', not_tagged: 'not tagged', unknown: 'unknown' } as const;

/** "Golden hour: tagged" / "Dead hour: unknown — no visits in that hour". */
export function verdictWords(name: string, v: HourTagVerdict): string {
  const why = v.state === 'unknown' ? hourTagWhy(v) : '';
  return `${name}: ${STATE[v.state]}${why ? ` — ${why}` : ''}`;
}

export const hourTagsTitle = (row: Tagged): string =>
  Object.entries(row.tags ?? {})
    .map(([name, v]) => verdictWords(name, v))
    .join('\n');
